<template>
  <div>
    <b-container class="clear-margin clear-padding" fluid>
      <b-row align-h="between">
        <b-col cols="8" class="text-start">
          <h4>Licensed users</h4>
          <h6 class="text-muted">All users below are part of your subscription and have shared access to your usage limits.</h6>
        </b-col>
        <b-col v-if="enableUpdateUsers && isOwner" cols="4" class="text-end">
          <b-button variant="primary" class="mt-1 mr-2-5" size="sm" @click="onAddUser()">
            <feather-icon icon="UserPlusIcon" size="14" />
            Add
          </b-button>
        </b-col>
      </b-row>
    </b-container>

    <b-table responsive :items="users" :fields="fields" class="mt-2">
      <template #cell(status)="row">
        <div v-if="row.item.status === 'Active'">
          <p class="clear-margin primary-color"><b>Active</b></p>
          <small class="text-muted">{{ row.item._id }}</small>
        </div>
        <div v-else-if="row.item.status === 'Owner'">
          <p class="clear-margin primary-color"><b>Business Owner</b></p>
          <small class="text-muted">{{ row.item._id }}</small>
        </div>
        <div v-else>
          <p class="clear-margin secondary-color"><b>Pending</b></p>
        </div>
      </template>

      <template #cell(edit)="row">
        <div v-if="isOwner" class="d-flex justify-content-end">
          <b-button v-if="row.item.status === 'Pending'" variant="primary" class="mt-1" size="sm" @click="onResendWelcomeAlert(row.item)">
            <feather-icon icon="MailIcon" size="14" />
            Resend welcome alert
          </b-button>
          <b-button v-if="row.item._id !== owner._id" variant="danger" class="ml-1 mt-1" size="sm" @click="onRemoveUser(row.item)">
            <feather-icon icon="TrashIcon" size="14" />
            Delete
          </b-button>
        </div>
      </template>
    </b-table>
    <CreateUserModal></CreateUserModal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Ripple from 'vue-ripple-directive'
import { BTable, BContainer, BRow, BCol, BButton } from 'bootstrap-vue'
import CreateUserModal from './CreateUserModal.vue'

export default {
  components: { BTable, BContainer, BRow, BCol, BButton, CreateUserModal },
  directives: {
    Ripple
  },
  data: function() {
    return {
      fields: [
        {
          key: 'status',
          label: 'Status'
        },

        {
          key: 'firstName',
          label: 'First Name'
        },
        {
          key: 'lastName',
          label: 'Last Name'
        },
        {
          key: 'email',
          label: 'Email'
        },
        {
          key: 'edit',
          label: ''
        }
      ]
    }
  },
  setup() {},
  computed: {
    ...mapState('userProfile', ['profile']),
    ...mapState('billing', ['owner', 'users', 'subscription']),
    enableUpdateUsers: {
      get() {
        return this.subscription.productName !== 'Basic'
      }
    },
    isOwner: {
      get() {
        return this.profile._id === this.owner._id
      }
    }
  },
  watch: {},
  methods: {
    onAddUser() {
      this.$store.dispatch('billingUserModal/onChangeModal', {
        self: this,
        visible: true
      })
    },
    onRemoveUser(event) {
      this.$store.dispatch('billing/removeUser', {
        self: this,
        ...event
      })
    },
    onResendWelcomeAlert(event) {
      this.$store.dispatch('billingUserModal/create', { firstName: event.firstName, lastName: event.lastName, email: event.email })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables/_variables';
.warning-icon {
  color: $red;
  cursor: pointer;
}

.primary-color {
  color: $primary;
}

.secondary-color {
  color: $secondary;
}

.mr-2-5 {
  margin-right: 2.5em;
}
</style>
